import { createApiResource, UnpagedListHookResult, UnpagedListResource } from '../apiResourceFactory';
import { ServiceTitanAPI } from '../apiService';
import { MembershipType } from '../apiTypes.shim';

interface ServiceTitanMembershipTypeResource extends UnpagedListResource<MembershipType> {
  useUnpagedListCached: () => UnpagedListHookResult<MembershipType>;
}

export const createServiceTitanMembershipTypeResource = (companyId: string): ServiceTitanMembershipTypeResource => {
  const membershipTypeUri = `${companyId}/membership-types`;
  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(ServiceTitanAPI, membershipTypeUri);

  return {
    useUnpagedList,
    unpagedList,
    unpagedListQueryKey,
    useUnpagedListCached: () => useUnpagedList({}, { refetchOnMount: false })
  };
};
